/// Single-IAP model: every paid level on web is unlocked by the
/// one $4.99 `FULL_UNLOCK` product. iOS's per-pack tier structure
/// (SMALL_FIELDS, MID_SIZE, ...) is intentionally collapsed on
/// web — Stripe hosts one product, the paywall shows one offer,
/// and the webhook writes one Firestore field.
///
/// The unlock plumbing (`purchases.ts`, `PaywallModal`) reads
/// this constant; the Cloud Function (`functions/src/stripe.ts`)
/// uses the same `stripeProductId` string as the lookup key for
/// the price ID set in the Stripe dashboard.

export const FULL_UNLOCK_PRODUCT_ID = 'FULL_UNLOCK' as const
export type FullUnlockProductId = typeof FULL_UNLOCK_PRODUCT_ID

export interface FullUnlockInfo {
  id: FullUnlockProductId
  /// Internal product key — the function maps this to the Stripe
  /// `price_…` ID. Update both sides if you ever rename it.
  stripeProductId: string
  displayName: string
  description: string
  /// Display price in USD. The actual amount + currency live on
  /// the Stripe Price; this is a snapshot for the paywall UI.
  defaultPriceUSD: number
}

export const FULL_UNLOCK: FullUnlockInfo = {
  id: FULL_UNLOCK_PRODUCT_ID,
  stripeProductId: 'FULL_UNLOCK',
  displayName: 'Full Game Unlock',
  description: 'Every level, every difficulty — one purchase, plays everywhere you sign in.',
  defaultPriceUSD: 4.99,
}
